





import { Component, Vue } from 'vue-property-decorator';

import ExpansionPanel from '@/shared/components/expansion.panel.component.vue';

@Component({
  components: {
    ExpansionPanel
  },
})
export default class PartialExpansionPanel extends Vue {
  private expansionState: boolean = true;
  private expansion2State: boolean = true;
}
